export function getTimer() {
  // Make sure not to have hydration issues while rendering associated components
  // server-side. This may happen in several situations such as:
  //
  //     1. The request processing takes a few seconds, meaning that
  //        both server and client timestamps would be different.
  //     2. Both server and client timezones being different.
  //
  // By returning a default value instead of throwing an error, we makes sure that the
  // application may still render in production. Crashing it would be far worst.
  if (process.server) {
    return { hours: 0, minutes: 0, seconds: 0 }
  }

  const now = new Date()
  const tomorrow = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1,
  )

  // We divide the timestamps by 1000 because we get miliseconds.
  const nowTimestamp = now.getTime() / 1000
  const tomorrowTimestamp = tomorrow.getTime() / 1000
  const difference = tomorrowTimestamp - nowTimestamp

  const hours = Math.floor(difference / 3600)
  const minutes = Math.floor((difference - hours * 3600) / 60)
  const seconds = Math.floor((difference - hours * 3600 - minutes * 60) % 60)

  return { hours, minutes, seconds }
}
